//styles and scss
import { styled } from "@mui/material/styles";

//components
import FormGroup from "@mui/material/FormGroup";
import Switch from "@mui/material/Switch";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

interface IAntSwitch {
  theme: any;
}

const AntSwitch = styled(Switch)(({ theme }: IAntSwitch) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(12px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: theme.palette.mode === "dark" ? "#177ddc" : "#1890ff",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor:
      theme.palette.mode === "dark"
        ? "rgba(255,255,255,.35)"
        : "rgba(0,0,0,.25)",
    boxSizing: "border-box",
  },
}));
interface IToggleField {
  checked: boolean;
  labelOne?: JSX.Element;
  labelTwo?: JSX.Element;
  input?: any;
  changeForm: (field: string, value: any) => void;
}

const SwitchButton = (props: IToggleField) => {
  const { checked, changeForm, labelOne, labelTwo, input } = props;
  const name = input ? input.name : "checkboxToggle";
  return (
    <FormGroup className={"text-nowrap"}>
      <Stack direction="row" spacing={1} alignItems="center">
        <Typography>{labelOne}</Typography>
        <AntSwitch
          onChange={() => {
            changeForm(name, !checked);
          }}
          checked={checked ? checked : false}
          inputProps={{ "aria-label": "ant design" }}
          theme={undefined}
        />
        <Typography>{labelTwo}</Typography>
      </Stack>
    </FormGroup>
  );
};

export default SwitchButton;
